import React from 'react';
import moment from 'moment';

import * as S from './styles';

function Info({ field, formattedValue = '' }) {
    const DATE_FORMAT = 'DD/MM/YYYY';

    const valueByTypeField = {
        text: field.value,
        number: field.value,
        select: field.lookup,
        radio: field.lookup,
        date: moment(field.value).format(DATE_FORMAT),
    };

    const exibitionValue = field.value ? valueByTypeField[field.type || 'text'] : '';

    if (!field.required && !field.value) {
        return <> </>;
    }

    return (
        <S.AlignField className="input-info">
            <S.TitleReview className="input-info_label">{field.label}</S.TitleReview>
            <S.SubtitleReview className="input-info_value">{formattedValue || exibitionValue}</S.SubtitleReview>
        </S.AlignField>
    );
}

export default Info;
